import React, { Component,Fragment } from 'react'
import Breadcrumb from "../../common/breadcrumb"
import Modal from 'react-responsive-modal';
import 'react-toastify/dist/ReactToastify.css';
import Datatable from '../../common/datatable'
import {Link} from 'react-router-dom'
import { getObjects, createObject, updateObject, deleteObject, stopTimer } from "../../api";


export class MenuList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            loading: true, // set to false once loading is completed
            error: '',
            file: '',
            img: {},
            editingRow: {},
            actionMode: ''
        };
    }

    onOpenModal = () => {
        this.setState({ editingRow: {}, actionMode: 'new', open: true });
    };

    onCloseModal = (mode) => {
        this.setState({ open: false });
        if(mode === true)
        {
            if (document.getElementById("newMenu").elements['actionMode'].value === 'new') {
                this.onCreateMenu();
            } else if (document.getElementById("newMenu").elements['actionMode'].value === 'update') {
                this.onUpdateMenu();
            } else {
                this.onDeleteMenu();
            }
        } else {
            console.log('cancel');
        }
    };

    _handleImgChange(e, i) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];
        const { img } = this.state;

        reader.onloadend = () => {
            img.path = null;
            img.img = reader.result;
            this.setState({
                file: file,
                img,
            });
        }
        reader.readAsDataURL(file)
    }

    onItemEdit = (row) => {
        this.props.history.push(`/admin/menu/edit?pid=${row._id}`)
        //this.setState({editingRow: row, actionMode: 'update', open: true });
    };

    onItemDelete = (row) => {
        this.setState({editingRow: row, actionMode: 'delete', open: true });        
    };

    formToJSON = elements => [].reduce.call(elements, (data, element) => {

        data[element.id] = element.value;
        return data;
      
      }, {});

    onCreateMenu = () => {
        const formData = new FormData(document.getElementById('newMenu'));
        if (this.state.file instanceof Blob ) formData.append('image', this.state.file, this.state.file.name);
        
        createObject('menu', formData).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadMenus();
            }
        });
    };

    onUpdateMenu = () => {
        const formData = new FormData(document.getElementById('newMenu'));
        if (this.state.file instanceof Blob ) formData.append('image', this.state.file, this.state.file.name);
        
        updateObject('menu', formData, this.state.editingRow._id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.loadMenus();
                }
            }
        );
    };

    onDeleteMenu = () => {
        const id = document.getElementById("newMenu").elements['itemId'].value;
        deleteObject('menu', id).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadMenus();
            }
        });
    };

    loadMenus = () => {
        this.setState({ loading: true});
        getObjects('menu').then(d2 => {
            if (d2 && d2.error) {
                this.setState( {error: d2.error, loading: false});
            } else {
                this.setState({ data: d2, loading: false});
            }
        });
    };

    componentDidMount(){
        this.loadMenus();
    }

    render() {
        const { open } = this.state;

        if (this.state.loading) { return null; }
        else 
        { 
            stopTimer();
            return (
                <Fragment>
                    <Breadcrumb title="Menu List" />
                    {/* <!-- Container-fluid starts--> */}
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="btn-popup pull-right">
                                            <Link to="/admin/menu/edit">
                                                <button type="button" className="btn btn-primary">Add Menu</button>  
                                            </Link> 
                                            <Modal open={open} onClose={this.onCloseModal} >
                                                <div className="modal-header">
                                                    <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                                                    {this.state.actionMode==='delete'?'Delete ':this.state.actionMode==='update'?'Update ':'Add '}
                                                    Menu</h5>
                                                </div>
                                                <div className="modal-body">
                                                    <form id="newMenu">
                                                        <input type="hidden" id="itemId" value={this.state.editingRow._id?this.state.editingRow._id:''} />
                                                        <input type="hidden" id="actionMode" value={this.state.actionMode} />
                                                        <div className="form-group">
                                                            <label htmlFor="recipient-title" className="col-form-label" >Menu Title :</label>
                                                            <input id="title" name="title" defaultValue={this.state.editingRow.title?this.state.editingRow.title:''} type="text" className="form-control" />
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true)}>{this.state.actionMode==='delete'?'Delete':'Save'}</button>
                                                    <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Close</button>
                                                </div>
                                            </Modal>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div id="basicScenario" className="product-physical">
                                            <Datatable
                                                multiSelectOption={false}
                                                myData={this.state.data} 
                                                columns={['title']}
                                                imageUrlField='imageUrl'
                                                imageSource='menu'
                                                pageSize={10} 
                                                pagination={true}
                                                onItemDelete={this.onItemDelete}
                                                onItemEdit={this.onItemEdit}
                                                class="-striped -highlight" 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Container-fluid Ends--> */}
                </Fragment>
            )
        }
    }
}

export default MenuList
